import { Dependencies } from "@planzone/core";
import { OidcLogin } from "./oidcAuthenticator";
import { Identifiable, Planzone } from "@planzone/dto";

function createGateKeeper(
  getCurrentPlanzone: () => Identifiable<Planzone>,
): Dependencies["gatekeeper"] {
  return {
    authenticate({ code }) {
      return code
        ? new OidcLogin(getCurrentPlanzone().uuid)
            .accessToken()
            .then(({ access_token, refresh_token, expires_in }) => ({
              accessToken: access_token,
              refreshToken: refresh_token,
              expiresAt: new Date().getTime() + expires_in * 1000 - 5000,
            }))
        : new Promise<any>(() =>
            new OidcLogin(getCurrentPlanzone().uuid).login(),
          );
    },
  };
}

export { createGateKeeper };
